import useQueryEncoder from '@/composables/useQueryEncoder'

// Global state for terminate contract modal
const showTerminateContractModal = useQueryEncoder(
  'terminate-contract',
  false,
  (v: string | boolean | number) => `${v}` === '1' || v === 'true' || v === true,
)

export function useTerminateContractModal() {
  const openTerminateContractModal = () => {
    showTerminateContractModal.value = true
  }

  const closeTerminateContractModal = () => {
    showTerminateContractModal.value = false
  }

  return {
    showTerminateContractModal,
    openTerminateContractModal,
    closeTerminateContractModal,
  }
}
